// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { useSelector, useDispatch } from 'react-redux';
// import { 
//   selectSelectedTemplate, 
//   selectTemplateVariables, 
//   updateTemplateVariable, 
//   setSelectedTemplate 
// } from '../../redux/reducers/templateSlice';
// import { 
//   sendTemplateMessage,
//   selectIsSending,
//   selectError,
//   clearError
// } from '../../redux/reducers/templateMessageSendSlice';
// import { TextField } from "@/subframe/components/TextField";
// import { Button } from "@/subframe/components/Button";
// import { IconButton } from "@/subframe/components/IconButton";
// import { Tooltip } from "@/subframe/components/Tooltip";
// import { Image, FileText, Video } from 'lucide-react';
// import * as SubframeCore from "@subframe/core";
// import { useEffect } from 'react';
// import { RootState, AppDispatch } from '../../redux/store';


// const TemplateMessageSend = ({currentRecipient}: any) => {
//   const dispatch = useDispatch<AppDispatch>();
//   const selectedTemplate = useSelector(selectSelectedTemplate);
//   const templateVariables = useSelector(selectTemplateVariables);
//   const isSending = useSelector(selectIsSending);
//   const errorMessage = useSelector(selectError);
//   const system_user_id = useSelector((state: RootState) => state.auth.system_user_id);

//   useEffect(() => {
//     return () => {
//       dispatch(clearError());
//     };
//   }, [dispatch]);

//   const handleSendMessage = async () => {
//     if (!selectedTemplate?.id || !currentRecipient || !system_user_id) return;

//     const variables: any = {};
//     Object.entries(templateVariables).forEach(([key, value]) => {
//       if (key.startsWith('b_')) {
//         variables[`body${key.slice(2)}`] = value;
//       } else if (key.startsWith('vw_')) {
//         const index = parseInt(key.slice(3));
//         if (index <= 2) {
//           variables[`visit_website${index > 1 ? index : ''}`] = value;
//         }
//       } else if (key === 'm_1') {
//         variables['media'] = value;
//       }
//     });

//     const payload = {
//       template: selectedTemplate.template_id,
//       variables,
//       current_recipient: currentRecipient,
//       user_id: system_user_id
//     };

//     await dispatch(sendTemplateMessage(payload));
//   };

//   // Rest of your component code remains exactly the same...

//   const renderHeaderMedia = (component: any) => {
//     if (!component?.format) return null;
//     const format = component.format.toLowerCase();
//     const iconMap: any = {
//       'image': <Image className="w-16 h-16 text-neutral-400" />,
//       'video': <Video className="w-16 h-16 text-neutral-400" />,
//       'document': <FileText className="w-16 h-16 text-neutral-400" />
//     };

//     if (format === 'image' && templateVariables.m_1) {
//       return (
//         <img
//           className="h-48 w-full flex-none rounded-t-lg object-cover"
//           src={templateVariables.m_1}
//           alt="Media preview"
//         />
//       );
//     }

//     return (
//       <div className="h-48 w-full flex-none rounded-t-lg bg-neutral-100 flex flex-col items-center justify-center">
//         {iconMap[format]}
//         <span className="mt-2 text-sm text-neutral-500">Add {format} URL</span>
//       </div>
//     );
//   };

//   const formatMessageText = (text: string) => {
//     if (!text) return '';
//     let processedText = text;
//     const rtlLanguages: ('ar' | 'he' | 'ur' | 'fa')[] = ['ar', 'he', 'ur', 'fa'];

//     Object.entries(templateVariables).forEach(([key, value]) => {
//       if (key.startsWith('b_')) {
//         const index = key.split('_')[1];
//         const placeholder = `{{${index}}}`;
//         const spanClass = value ? 'bg-green-100' : 'bg-blue-100';
//         const displayValue = value || placeholder;
//         processedText = processedText.replace(
//           placeholder,
//           `<span class="${spanClass} px-1 rounded text-blue-600 inline-block">${displayValue}</span>`
//         );
//       }
//     });

//     const textDirection = rtlLanguages.includes(selectedTemplate?.language?.toLowerCase() as 'ar' | 'he' | 'ur' | 'fa')
//       ? 'rtl'
//       : 'ltr';

//     return (
//       <span 
//         className="whitespace-pre-wrap w-full"
//         style={{ 
//           direction: textDirection,
//           textAlign: textDirection === 'rtl' ? 'right' : 'left'
//         }}
//         dangerouslySetInnerHTML={{ 
//           __html: processedText.split('\n').join('<br />') 
//         }} 
//       />
//     );
//   };

//   const renderTextField: any = (key: string, value: string, label: string, placeholder: string, icon: any, iconRight: undefined, helpText: string) => {
//     let headerIcon: any = icon;

//     switch (true) {
//       case key === 'm_1':
//         switch (headerComponent?.format?.toLowerCase()) {
//           case 'image':
//             headerIcon = 'FeatherImage';
//             break;
//           case 'video':
//             headerIcon = 'FeatherVideo';
//             break;
//           case 'document':
//             headerIcon = 'FeatherFile';
//             break;
//         }
//         break;
//       case key.startsWith('vw_'):
//         headerIcon = 'FeatherLink';
//         break;
//     }

//     return (
//       <TextField
//         className="h-auto w-full flex-none"
//         label={label}
//         helpText={helpText}
//         icon={headerIcon}
//         iconRight={iconRight}
//       >
//         <TextField.Input
//           placeholder={placeholder}
//           value={value}
//           onChange={(e) => dispatch(updateTemplateVariable({ key, value: e.target.value }))}
//         />
//       </TextField>
//     );
//   };

//   const parseTemplateFormat = (format: string) => {
//     if (!format) return [];
//     const variables: { type: string, count: number }[] = [];
//     const formatParts = format.slice(1, -1).split(',').map(part => part.trim());

//     formatParts.forEach(part => {
//       const [type, count] = part.split(':');
//       variables.push({ type: type.trim(), count: parseInt(count) });
//     });

//     return variables;
//   };

//   if (!selectedTemplate) return null;

//   const headerComponent: any = selectedTemplate.components.components.find(comp => comp.type === 'HEADER');
//   const bodyComponent: any = selectedTemplate.components.components.find(comp => comp.type === 'BODY');
//   const formatVariables = parseTemplateFormat(selectedTemplate.template_formate);
//   const hasWebsiteVariables = formatVariables.some(v => v.type === 'vw');

//   return (
//     <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-4 py-4 shadow-sm">
//       <div className="flex w-full flex-col items-end gap-4">
//         <IconButton
//           variant="neutral-secondary"
//           icon="FeatherX"
//           onClick={() => dispatch(setSelectedTemplate(null))}
//         />
//       </div>
//       <div className="flex w-full grow shrink-0 basis-0 items-start gap-6">
//         <div className="flex grow shrink-0 basis-0 flex-col items-start gap-3 self-stretch">
//           <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-6 py-6 shadow-sm">
//             <div className="flex w-full flex-col items-start gap-4">
//               {headerComponent && renderTextField(
//                 'm_1',
//                 templateVariables['m_1'] || '',
//                 `${headerComponent.format}`,
//                 `${headerComponent.format.toLowerCase()} url`,
//                 'FeatherLink',
//                 undefined,
//                 `Insert a public ${headerComponent.format.toLowerCase()} URL for your template message.`
//               )}
//               {bodyComponent?.example?.body_text?.[0]?.map((_: any, index: number) => (
//                 renderTextField(
//                   `b_${index + 1}`,
//                   templateVariables[`b_${index + 1}`] || '',
//                   `Body Variable {{${index + 1}}}`,
//                   `e.g., Variable ${index + 1}`,
//                   'FeatherCurlyBraces',
//                   undefined,
//                   ''
//                 )
//               ))}
//               {hasWebsiteVariables && formatVariables
//                 .filter(v => v.type === 'vw')
//                 .map(({ count }) => {
//                   const fields = [];
//                   for (let i = 1; i <= Math.min(count, 2); i++) {
//                     fields.push(
//                       renderTextField(
//                         `vw_${i}`,
//                         templateVariables[`vw_${i}`] || '',
//                         `Visit Website URL ${i > 1 ? i : ''}`,
//                         'Enter website URL',
//                         'FeatherLink',
//                         undefined,
//                         ''
//                       )
//                     );
//                   }
//                   return fields;
//                 })}
//             </div>
//           </div>
//           <div className="flex w-full flex-col items-start gap-1">
//             <div className="flex w-full grow shrink-0 basis-0 flex-col items-center gap-4">
//               <div className="flex grow shrink-0 basis-0 items-center rounded-lg bg-brand-600">
//                 <SubframeCore.Tooltip.Provider>
//                   <SubframeCore.Tooltip.Root>
//                     <SubframeCore.Tooltip.Trigger asChild={true}>
//                       <IconButton
//                         className="h-auto w-8 flex-none self-stretch"
//                         variant="brand-primary"
//                         icon="FeatherCalendarClock"
//                       />
//                     </SubframeCore.Tooltip.Trigger>
//                     <SubframeCore.Tooltip.Portal>
//                       <SubframeCore.Tooltip.Content
//                         side="bottom"
//                         align="center"
//                         sideOffset={4}
//                         asChild={true}
//                       >
//                         <Tooltip>Schedule send</Tooltip>
//                       </SubframeCore.Tooltip.Content>
//                     </SubframeCore.Tooltip.Portal>
//                   </SubframeCore.Tooltip.Root>
//                 </SubframeCore.Tooltip.Provider>
//                 <div className="flex w-px flex-none flex-col items-center gap-2 self-stretch bg-brand-50" />
//                 <Button
//                   className="h-auto min-h-[36px] w-auto flex-none self-stretch"
//                   iconRight="FeatherSendHorizontal"
//                   onClick={handleSendMessage}
//                   disabled={isSending || !currentRecipient}
//                 >
//                   {isSending ? 'Sending...' : 'Send'}
//                 </Button>
//               </div>
//             </div>
//             {errorMessage && 
//               (<span className="w-full whitespace-pre-wrap break-words text-caption-bold font-caption-bold text-error-600 text-center">
//                 {errorMessage}
//               </span>)
//             }
//           </div>
//         </div>
//         <div className="flex grow shrink-0 basis-0 items-start justify-center gap-6">
//           <div className="flex grow shrink-0 basis-0 flex-col items-center">
//             <div className="flex w-full flex-col items-center gap-3 px-4 pb-4">
//               <span className="text-heading-3 font-heading-3 text-default-font">
//                 How the message will appear:
//               </span>
//               <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-lg">
//                 <div className="w-full h-full flex flex-col bg-[#eae7dcff] p-2">
//                   <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-lg">
//                     {renderHeaderMedia(headerComponent)}
//                     <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-6 px-4 pt-4 pb-0.5">
//                       {formatMessageText(bodyComponent?.text)}
//                     </div>
//                     <div className="flex w-full flex-col items-start">
//                       {selectedTemplate.components.components
//                         .find(comp => comp.type === 'BUTTONS')
//                         ?.buttons?.map((button, index) => (
//                           <div key={index} className="flex w-full flex-col items-center justify-center gap-2 border-t-2 border-solid border-neutral-border px-3 py-3">
//                             <div className="flex items-center gap-2">
//                               <SubframeCore.Icon
//                                 className="text-heading-3 font-heading-3 text-[#10b989ff]"
//                                 name={
//                                   button.type === 'QUICK_REPLY' ? 'FeatherReply' :
//                                   button.type === 'URL' ? 'FeatherArrowUpRightSquare' :
//                                   button.type === 'PHONE_NUMBER' ? 'FeatherPhone' :
//                                   button.type === 'COPY_CODE' ? 'FeatherCopy' : 'FeatherList'
//                                 }
//                               />
//                               <span className="font-['Nunito'] text-[16px] font-[600] leading-[20px] text-success-500">
//                                 {button.text}
//                               </span>
//                             </div>
//                           </div>
//                         ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TemplateMessageSend;





/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSelectedTemplate,
  selectTemplateVariables,
  updateTemplateVariable,
  setSelectedTemplate
} from '../../redux/reducers/templateSlice';
import {
  sendTemplateMessage,
  selectIsSending,
  selectError,
  clearError
} from '../../redux/reducers/templateMessageSendSlice';
import { addNotification } from "../../redux/reducers/notificationSlice";
import { NotificationIcon, NotificationType } from "../../Utils/notificationEnums";
import { TextField } from "@/subframe/components/TextField";
import { Button } from "@/subframe/components/Button";
import { IconButton } from "@/subframe/components/IconButton";
import { Tooltip } from "@/subframe/components/Tooltip";
import { Image, FileText, Video } from 'lucide-react';
import * as SubframeCore from "@subframe/core";
import { useEffect, useState } from 'react';
import { RootState, AppDispatch, store } from '../../redux/store';
import SelectDateAndTimePopup from '../subcomponents/SelectDateAndTimePopup';
import moment from "moment";
import { sendRecipientDetails } from '../../Utils/recipientDetailsUtils';

const TemplateMessageSend = ({ currentRecipient }: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const selectedTemplate = useSelector(selectSelectedTemplate);
  const templateVariables = useSelector(selectTemplateVariables);
  const isSending = useSelector(selectIsSending);
  const errorMessage = useSelector(selectError);
  const system_user_id = useSelector((state: RootState) => state.auth.system_user_id);
  const [isDateTimePopupOpen, setIsDateTimePopupOpen] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  // const handleSendMessage = async (scheduledTime?: number) => {
  //   if (!selectedTemplate?.id || !currentRecipient || !system_user_id) return;

  //   // Validate template variables before sending
  //   const missingRequiredVariables = validateTemplateVariables();
  //   if (missingRequiredVariables.length > 0) {
  //     dispatch(
  //       addNotification({
  //         id: Date.now(),
  //         type: NotificationType.ERROR,
  //         title: "Template Validation Failed",
  //         message: `Please fill in the following required fields: ${missingRequiredVariables.join(', ')}`,
  //         icon: NotificationIcon.ERROR,
  //       })
  //     );
  //     return;
  //   }

  //   const variables: any = {};
  //   Object.entries(templateVariables).forEach(([key, value]) => {
  //     if (key.startsWith('b_')) {
  //       variables[`body${key.slice(2)}`] = value;
  //     } else if (key.startsWith('vw_')) {
  //       const index = parseInt(key.slice(3));
  //       if (index <= 2) {
  //         variables[`visit_website${index > 1 ? index : ''}`] = value;
  //       }
  //     } else if (key === 'm_1') {
  //       variables['media'] = value;
  //     }
  //   });

  //   const payload = {
  //     template: selectedTemplate.template_id,
  //     variables,
  //     current_recipient: currentRecipient,
  //     user_id: system_user_id,
  //     ...(scheduledTime ? { scheduled_time: scheduledTime } : {})
  //   };

  //   try {
  //     const result = await dispatch(sendTemplateMessage(payload)).unwrap();

  //     // Clear all input fields after successful send
  //     // Manually clear each template variable by setting each to empty string
  //     if (templateVariables) {
  //       Object.keys(templateVariables).forEach(key => {
  //         dispatch(updateTemplateVariable({ key, value: '' }));
  //       });
  //     }

  //     // Show different notifications based on message type
  //     if (scheduledTime) {
  //       // For scheduled messages
  //       const formattedDateTime = moment(scheduledTime).format('MMM D, YYYY hh:mm A');
  //       dispatch(
  //         addNotification({
  //           id: Date.now(),
  //           type: NotificationType.SUCCESS,
  //           title: "Template Scheduled",
  //           message: `Your template message will be sent on ${formattedDateTime}`,
  //           icon: NotificationIcon.SUCCESS,
  //         })
  //       );
  //     } else {
  //       // For instant messages
  //       dispatch(
  //         addNotification({
  //           id: Date.now(),
  //           type: NotificationType.SUCCESS,
  //           title: "Template Sent",
  //           message: "Your template message has been sent successfully",
  //           icon: NotificationIcon.SUCCESS,
  //         })
  //       );
  //     }

  //     return result;
  //   } catch (error: any) {
  //     // Error notification can also be different based on scheduled vs. instant
  //     const errorTitle = scheduledTime ? "Template Schedule Failed" : "Template Not Sent";
  //     dispatch(
  //       addNotification({
  //         id: Date.now(),
  //         type: NotificationType.ERROR,
  //         title: errorTitle,
  //         message: error.message || "Something went wrong. Please try again.",
  //         icon: NotificationIcon.ERROR,
  //       })
  //     );
  //     console.error("Error sending/scheduling template message:", error);
  //     throw error;
  //   }
  // };

  const handleSendMessage = async (scheduledTime?: number) => {
    if (!selectedTemplate?.id || !currentRecipient || !system_user_id) return;

    // Validate template variables before sending
    const missingRequiredVariables = validateTemplateVariables();
    if (missingRequiredVariables.length > 0) {
      dispatch(
        addNotification({
          id: Date.now(),
          type: NotificationType.ERROR,
          title: "Template Validation Failed",
          message: `Please fill in the following required fields: ${missingRequiredVariables.join(', ')}`,
          icon: NotificationIcon.ERROR,
        })
      );
      return;
    }

    const variables: any = {};
    Object.entries(templateVariables).forEach(([key, value]) => {
      if (key.startsWith('b_')) {
        variables[`body${key.slice(2)}`] = value;
      } else if (key.startsWith('vw_')) {
        const index = parseInt(key.slice(3));
        if (index <= 2) {
          variables[`visit_website${index > 1 ? index : ''}`] = value;
        }
      } else if (key === 'm_1') {
        variables['media'] = value;
      }
    });

    const payload = {
      template: selectedTemplate.template_id,
      variables,
      current_recipient: currentRecipient,
      user_id: system_user_id,
      ...(scheduledTime ? { scheduled_time: scheduledTime } : {})
    };

    try {
      const result = await dispatch(sendTemplateMessage(payload)).unwrap();

      // Check if the API call was successful
      if (!result.success) {
        // Extract error message from WhatsApp response based on available structure
        const whatsappResponse = result.whatsapp_response_info as any;
        let errorMessage = "Message could not be sent. Please try again.";

        // Try to get the most specific error message available
        if (whatsappResponse) {
          if (whatsappResponse.error_user_msg) {
            // First structure - has error_user_msg
            errorMessage = whatsappResponse.error_user_msg;
          } else if (whatsappResponse.error_data?.details) {
            // Second structure - has error_data.details
            errorMessage = whatsappResponse.error_data.details;
          } else if (whatsappResponse.message) {
            // Fallback to general message if available
            errorMessage = whatsappResponse.message;
          }
        }

        // Show the error message in the notification
        dispatch(
          addNotification({
            id: Date.now(),
            type: NotificationType.ERROR,
            title: "Template Message Failed",
            message: errorMessage,
            icon: NotificationIcon.ERROR,
          })
        );

        return result;
      }

      // Clear all input fields after successful send
      if (templateVariables) {
        Object.keys(templateVariables).forEach(key => {
          dispatch(updateTemplateVariable({ key, value: '' }));
        });
      }

      // Send recipient details to API
      try {
        const state = store.getState();
        const token = state.auth.token;
        await sendRecipientDetails(currentRecipient, token);
      } catch (error: any) {
        // Log error but don't show notification - this is a non-critical operation
        console.error('Failed to send recipient details:', error);
      }

      // Show different notifications based on message type
      if (scheduledTime) {
        // For scheduled messages
        const formattedDateTime = moment(scheduledTime).format('MMM D, YYYY hh:mm A');
        dispatch(
          addNotification({
            id: Date.now(),
            type: NotificationType.SUCCESS,
            title: "Template Scheduled",
            message: `Your template message will be sent on ${formattedDateTime}`,
            icon: NotificationType.SUCCESS,
          })
        );
      } else {
        // For instant messages
        dispatch(
          addNotification({
            id: Date.now(),
            type: NotificationType.SUCCESS,
            title: "Template Sent",
            message: "Your template message has been sent successfully",
            icon: NotificationType.SUCCESS,
          })
        );
      }

      return result;
    } catch (error: any) {
      // Handle errors thrown during the API call
      const whatsappResponse = error.whatsapp_response_info as any;
      let errorMessage = error.message || "Something went wrong. Please try again.";

      // Try to get the most specific error message available
      if (whatsappResponse) {
        if (whatsappResponse.error_user_msg) {
          // First structure - has error_user_msg
          errorMessage = whatsappResponse.error_user_msg;
        } else if (whatsappResponse.error_data?.details) {
          // Second structure - has error_data.details
          errorMessage = whatsappResponse.error_data.details;
        } else if (whatsappResponse.message) {
          // Fallback to general message if available
          errorMessage = whatsappResponse.message;
        }
      }

      // Error notification can be different based on scheduled vs. instant
      const errorTitle = scheduledTime ? "Template Schedule Failed" : "Template Not Sent";

      dispatch(
        addNotification({
          id: Date.now(),
          type: NotificationType.ERROR,
          title: errorTitle,
          message: errorMessage,
          icon: NotificationIcon.ERROR,
        })
      );

      throw error;
    }
  };


  const handleScheduleMessage = (scheduledTime: number) => {
    // In template messages, we ignore the text parameter since we're not sending text
    // We just pass the scheduledTime to the handleSendMessage function
    handleSendMessage(scheduledTime);
  };

  // Rest of the component code remains the same...

  const renderHeaderMedia = (component: any) => {
    if (!component?.format) return null;
    const format = component.format.toLowerCase();
    const iconMap: any = {
      'image': <Image className="w-16 h-16 text-neutral-400" />,
      'video': <Video className="w-16 h-16 text-neutral-400" />,
      'document': <FileText className="w-16 h-16 text-neutral-400" />
    };

    if (format === 'image' && templateVariables.m_1) {
      return (
        <img
          className="h-48 w-full flex-none rounded-t-lg object-cover"
          src={templateVariables.m_1}
          alt="Media preview"
        />
      );
    }

    return (
      <div className="h-48 w-full flex-none rounded-t-lg bg-neutral-100 flex flex-col items-center justify-center">
        {iconMap[format]}
        <span className="mt-2 text-sm text-neutral-500">Add {format} URL</span>
      </div>
    );
  };

  const formatMessageText = (text: string) => {
    if (!text) return '';
    let processedText = text;
    const rtlLanguages: ('ar' | 'he' | 'ur' | 'fa')[] = ['ar', 'he', 'ur', 'fa'];

    Object.entries(templateVariables).forEach(([key, value]) => {
      if (key.startsWith('b_')) {
        const index = key.split('_')[1];
        const placeholder = `{{${index}}}`;
        const spanClass = value ? 'bg-green-100' : 'bg-blue-100';
        const displayValue = value || placeholder;
        processedText = processedText.replace(
          placeholder,
          `<span class="${spanClass} px-1 rounded text-blue-600 inline-block">${displayValue}</span>`
        );
      }
    });

    const textDirection = rtlLanguages.includes(selectedTemplate?.language?.toLowerCase() as 'ar' | 'he' | 'ur' | 'fa')
      ? 'rtl'
      : 'ltr';

    return (
      <span
        className={`whitespace-pre-wrap w-full ${textDirection === 'rtl' ? 'text-rtl' : 'text-ltr'}`}
        dangerouslySetInnerHTML={{
          __html: processedText.split('\n').join('<br />')
        }}
      />
    );
  };

  const renderTextField: any = (key: string, value: string, label: string, placeholder: string, icon: any, iconRight: undefined, helpText: string) => {
    let headerIcon: any = icon;

    switch (true) {
      case key === 'm_1':
        switch (headerComponent?.format?.toLowerCase()) {
          case 'image':
            headerIcon = 'FeatherImage';
            break;
          case 'video':
            headerIcon = 'FeatherVideo';
            break;
          case 'document':
            headerIcon = 'FeatherFile';
            break;
        }
        break;
      case key.startsWith('vw_'):
        headerIcon = 'FeatherLink';
        break;
    }

    return (
      <TextField
        className="h-auto w-full flex-none"
        label={label}
        helpText={helpText}
        icon={headerIcon}
        iconRight={iconRight}
      >
        <TextField.Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => dispatch(updateTemplateVariable({ key, value: e.target.value }))}
        />
      </TextField>
    );
  };

  const parseTemplateFormat = (format: string) => {
    if (!format) return [];
    const variables: { type: string, count: number }[] = [];
    const formatParts = format.slice(1, -1).split(',').map(part => part.trim());

    formatParts.forEach(part => {
      const [type, count] = part.split(':');
      variables.push({ type: type.trim(), count: parseInt(count) });
    });

    return variables;
  };

  // Function to validate template variables before sending
  const validateTemplateVariables = (): string[] => {
    const missingFields: string[] = [];

    // Check header component variable if it exists and is required
    if (headerComponent?.format && !templateVariables.m_1) {
      missingFields.push(`${headerComponent.format} URL`);
    }

    // Check body variables
    bodyComponent?.example?.body_text?.[0]?.forEach((_: any, index: number) => {
      const key = `b_${index + 1}`;
      // Check if this body variable is required in the template - we can assume all are required
      if (!templateVariables[key]) {
        missingFields.push(`Body Variable {{${index + 1}}}`);
      }
    });

    // Check website variables if they exist in the template format
    if (hasWebsiteVariables) {
      formatVariables
        .filter(v => v.type === 'vw')
        .forEach(({ count }) => {
          for (let i = 1; i <= Math.min(count, 2); i++) {
            const key = `vw_${i}`;
            if (!templateVariables[key]) {
              missingFields.push(`Visit Website URL ${i > 1 ? i : ''}`);
            }
          }
        });
    }

    return missingFields;
  };

  if (!selectedTemplate) return null;

  const headerComponent: any = selectedTemplate.components.components.find(comp => comp.type === 'HEADER');
  const bodyComponent: any = selectedTemplate.components.components.find(comp => comp.type === 'BODY');
  const formatVariables = parseTemplateFormat(selectedTemplate.template_formate);
  const hasWebsiteVariables = formatVariables.some(v => v.type === 'vw');

  return (
    <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-4 py-4 shadow-sm">
      <div className="flex w-full flex-col items-end gap-4">
        <IconButton
          variant="neutral-secondary"
          icon="FeatherX"
          onClick={() => dispatch(setSelectedTemplate(null))}
        />
      </div>
      <div className="flex w-full grow shrink-0 basis-0 items-start gap-6">
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-3 self-stretch">
          <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-6 py-6 shadow-sm">
            <div className="flex w-full flex-col items-start gap-4">
              {headerComponent && renderTextField(
                'm_1',
                templateVariables['m_1'] || '',
                `${headerComponent.format}`,
                `${headerComponent.format.toLowerCase()} url`,
                'FeatherLink',
                undefined,
                `Insert a public ${headerComponent.format.toLowerCase()} URL for your template message.`
              )}
              {bodyComponent?.example?.body_text?.[0]?.map((_: any, index: number) => (
                renderTextField(
                  `b_${index + 1}`,
                  templateVariables[`b_${index + 1}`] || '',
                  `Body Variable {{${index + 1}}}`,
                  `e.g., Variable ${index + 1}`,
                  'FeatherCurlyBraces',
                  undefined,
                  ''
                )
              ))}
              {hasWebsiteVariables && formatVariables
                .filter(v => v.type === 'vw')
                .map(({ count }) => {
                  const fields = [];
                  for (let i = 1; i <= Math.min(count, 2); i++) {
                    fields.push(
                      renderTextField(
                        `vw_${i}`,
                        templateVariables[`vw_${i}`] || '',
                        `Visit Website URL ${i > 1 ? i : ''}`,
                        'Enter website URL',
                        'FeatherLink',
                        undefined,
                        ''
                      )
                    );
                  }
                  return fields;
                })}
            </div>
          </div>
          <div className="flex w-full flex-col items-start gap-1">
            <div className="flex w-full grow shrink-0 basis-0 flex-col items-center gap-4">
              <div className="flex grow shrink-0 basis-0 items-center rounded-lg bg-brand-600">
                <SubframeCore.Tooltip.Provider>
                  <SubframeCore.Tooltip.Root>
                    <SubframeCore.Tooltip.Trigger asChild={true}>
                      <IconButton
                        className="h-auto w-8 flex-none self-stretch"
                        variant="brand-primary"
                        icon="FeatherCalendarClock"
                        onClick={() => setIsDateTimePopupOpen(true)}
                      />
                    </SubframeCore.Tooltip.Trigger>
                    <SubframeCore.Tooltip.Portal>
                      <SubframeCore.Tooltip.Content
                        side="bottom"
                        align="center"
                        sideOffset={4}
                        asChild={true}
                      >
                        <Tooltip>Schedule send</Tooltip>
                      </SubframeCore.Tooltip.Content>
                    </SubframeCore.Tooltip.Portal>
                  </SubframeCore.Tooltip.Root>
                </SubframeCore.Tooltip.Provider>
                <div className="flex w-px flex-none flex-col items-center gap-2 self-stretch bg-brand-50" />
                <Button
                  className="h-auto min-h-[36px] w-auto flex-none self-stretch"
                  iconRight="FeatherSendHorizontal"
                  onClick={() => handleSendMessage()}
                  disabled={isSending || !currentRecipient}
                >
                  {isSending ? 'Sending...' : 'Send'}
                </Button>
              </div>
            </div>
            {errorMessage &&
              (<span className="w-full whitespace-pre-wrap break-words text-caption-bold font-caption-bold text-error-600 text-center">
                {errorMessage}
              </span>)
            }
          </div>
        </div>
        <div className="flex grow shrink-0 basis-0 items-start justify-center gap-6">
          <div className="flex grow shrink-0 basis-0 flex-col items-center">
            <div className="flex w-full flex-col items-center gap-3 px-4 pb-4">
              <span className="text-heading-3 font-heading-3 text-default-font">
                How the message will appear:
              </span>
              <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-lg">
                <div className="w-full h-full flex flex-col bg-[#eae7dcff] p-2">
                  <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-lg">
                    {renderHeaderMedia(headerComponent)}
                    <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-6 px-4 pt-4 pb-0.5">
                      {formatMessageText(bodyComponent?.text)}
                    </div>
                    <div className="flex w-full flex-col items-start">
                      {selectedTemplate.components.components
                        .find(comp => comp.type === 'BUTTONS')
                        ?.buttons?.map((button, index) => (
                          <div key={index} className="flex w-full flex-col items-center justify-center gap-2 border-t-2 border-solid border-neutral-border px-3 py-3">
                            <div className="flex items-center gap-2">
                              <SubframeCore.Icon
                                className="text-heading-3 font-heading-3 text-[#10b989ff]"
                                name={
                                  button.type === 'QUICK_REPLY' ? 'FeatherReply' :
                                    button.type === 'URL' ? 'FeatherArrowUpRightSquare' :
                                      button.type === 'PHONE_NUMBER' ? 'FeatherPhone' :
                                        button.type === 'COPY_CODE' ? 'FeatherCopy' : 'FeatherList'
                                }
                              />
                              <span className="font-['Nunito'] text-[16px] font-[600] leading-[20px] text-success-500">
                                {button.text}
                              </span>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Date and Time Popup for Scheduling */}
      <SelectDateAndTimePopup
        open={isDateTimePopupOpen}
        setSelectDateAndTimePopupOpen={setIsDateTimePopupOpen}
        onScheduleMessage={handleScheduleMessage}
        messageText=""  // We pass an empty string since we don't need text content for template messages
      />
    </div>
  );
};

export default TemplateMessageSend;